import { UpdateAreasOfExpertiseMutation } from '@typings/operations';
import { useMutation } from '@apollo/client';
import { updateAreasOfExpertiseMutation } from '../queries';

export const useUpdateAreasOfExpertiseMutation = () => {
  return useMutation<UpdateAreasOfExpertiseMutation>(
    updateAreasOfExpertiseMutation
  );
};
